import { useReducer } from 'react';
import { Details, File, FormMarkup, HelpWith } from '@components/basicComponents';
import { getSortedFormFields, handleFormSubmit } from '@utils/forms';
import { HelpWithType } from '@customTypes/enums';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormProps } from '@customTypes/types';
import type { MarketplaceGLCPFormState } from '@customTypes/stateTypes';
import { helpWithOptions } from './MarketplaceGLCPFormOptions';

const formTitle: string = 'HPE GreenLake Marketplace';

export const MarketplaceGLCPForm = (props: FormProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: MarketplaceGLCPFormState, newState: Partial<MarketplaceGLCPFormState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: '',
      showDetails: false,
      numFiles: 0,
    }
  );

  const onFileChange = (value: number): void => {
    updateState({ numFiles: value });
  };

  const onSubmit = ({ target }: FormExtendedEvent): void => {
    let namespace: string = 'hpe_marketplace';
    let subject: string = 'Marketplace : {formId}';
    const data = getSortedFormFields(target, namespace, subject);

    handleFormSubmit(data, props.onSuccess, props.onError, props.onLoading);
  };

  const onReset = (): void => {
    updateState({ helpWith: '', showDetails: false, numFiles: 0 });
  };

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    updateState({ helpWith: option, showDetails: true });
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      onReset={onReset}
      formTitle={formTitle}
      doubleFieldPhone
      formFields={
        <>
          <HelpWith
            selectType={HelpWithType.First}
            options={Object.values(helpWithOptions)}
            onChange={helpWithChange}
          />

          {state.showDetails &&
            <>
              <Details required={false} />

              <File numFiles={state.numFiles} onFileChange={onFileChange} />
            </>
          }
        </>
      }
    />
  );
};
